import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable, map} from 'rxjs';
import { plainToInstance } from 'class-transformer';
import { Exercise } from '../models/exercise.model';
import { CurrentExercise } from '../models/current-exercise.model';

@Injectable({
  providedIn: 'root'
})
export class ExerciseService {

  private apiUrl = `${environment.sgcApi}`;
  private exerciseRoute = 'exercise';

  constructor(
    private httpClient: HttpClient,
  ) {}

  getExercises(): Observable<Exercise[]> {
    let endpoint = `${this.apiUrl}${this.exerciseRoute}/map`;
    return this.httpClient.get<Exercise[]>(endpoint)
    .pipe(map((data) => {
      return plainToInstance(Exercise, data as Exercise[]);
    }));
  }

  getCurrentExercise(): Observable<CurrentExercise> {
    let endpoint = `${this.apiUrl}${this.exerciseRoute}/current`;
    return this.httpClient.get<CurrentExercise>(endpoint)
    .pipe(map((data) => {
      return plainToInstance(CurrentExercise, data as CurrentExercise);
    }));
  }

  createExercise(exceriseYear: number) {
    let endpoint = `${this.apiUrl}${this.exerciseRoute}/${exceriseYear}/create`;
    return this.httpClient.post(endpoint, null);
  }
}
